'use client';

import { FC } from 'react';
import { useTheme } from 'next-themes';
import { useIsSSR } from '@react-aria/ssr';
import { Button } from '@heroui/react';

import { SunFilledIcon, MoonFilledIcon } from '@/components/icons';

export interface ThemeSwitchProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  iconSize?: number;
}

export const ThemeSwitch: FC<ThemeSwitchProps> = ({ className, size = 'lg', iconSize = 22 }) => {
  const { theme, setTheme } = useTheme();
  const isSSR = useIsSSR();

  const isDark = !isSSR && theme === 'dark';

  return (
    <Button
      size={size}
      variant="ghost"
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      onPress={() => { setTheme(isDark ? 'light' : 'dark'); }}
      className={className}
    >
      {isDark ? (
        <SunFilledIcon size={iconSize} style={{ width: `${iconSize}px`, height: `${iconSize}px` }} />
      ) : (
        <MoonFilledIcon size={iconSize} style={{ width: `${iconSize}px`, height: `${iconSize}px` }} />
      )}
    </Button>
  );
};
